{
  "name": "lta-activators-client",
  "version": "1.0.0",
  "description": "LTA Activators frontend",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "start": "vite preview",
    "build": "tsc && vite build",
    "lint": "eslint \"src/**/*.{js,jsx,ts,tsx}\"",
    "fix": "eslint --fix \"src/**/*.{js,jsx,ts,tsx}\"",
    "fm:check": "prettier --check \"src/**/*.{js,jsx,ts,tsx}\"",
    "fm:fix": "prettier --write \"src/**/*.{js,jsx,ts,tsx}\"",
    "tsc:watch": "tsc --noEmit --watch",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "engines": {
    "npm": ">=11.6.0",
    "node": ">=24.10.0"
  },
  "dependencies": {
    "@bprogress/react": "^1.2.7",
    "@emotion/cache": "^11.14.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@hookform/resolvers": "^5.2.2",
    "@mui/icons-material": "^9.0.1",
    "@mui/material": "^9.0.1",
    "@mui/system": "^9.0.1",
    "@mui/utils": "^9.0.1",
    "@mui/x-date-pickers": "^9.1.0",
    "@tanstack/react-query": "^5.83.0",
    "axios": "^1.16.0",
    "dayjs": "^1.11.20",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "motion": "^12.38.0",
    "posthog-js": "^1.373.4",
    "react": "19.2.6",
    "react-dom": "19.2.6",
    "react-helmet-async": "^3.0.0",
    "react-hook-form": "^7.60.0",
    "react-router": "^7.15.0",
    "stylis": "^4.4.0",
    "stylis-plugin-rtl": "^2.1.1",
    "zod": "^4.4.3",
    "zustand": "^5.0.13"
  },
  "devDependencies": {
    "@eslint/js": "^9.17.0",
    "@storybook/builder-vite": "^10.3.6",
    "@storybook/react-vite": "^10.3.6",
    "@tanstack/react-query-devtools": "^5.85.8",
    "@types/node": "^24.12.4",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@types/stylis": "^4.2.7",
    "@typescript-eslint/parser": "^8.19.0",
    "@vitejs/plugin-react-swc": "^4.3.0",
    "eslint": "^9.17.0",
    "eslint-config-prettier": "^10.1.5",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-perfectionist": "^4.4.0",
    "eslint-plugin-prettier": "^5.5.1",
    "eslint-plugin-react": "^7.37.3",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-storybook": "^10.3.6",
    "eslint-plugin-unused-imports": "^4.1.4",
    "globals": "^17.6.0",
    "prettier": "^3.6.2",
    "storybook": "^10.3.6",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.19.0",
    "vite": "^8.0.12",
    "vite-plugin-checker": "^0.13.0"
  }
}
